import type { SVGProps } from 'react';
const SvgNavChevronRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    height={24}
    fill="none"
    width={24}
    {...props}
  >
    <path
      d="M9.575 12 5 7.4 6.4 6l6 6-6 6L5 16.6zm6.6 0L11.6 7.4 13 6l6 6-6 6-1.4-1.4z"
      fill="currentColor"
    />
  </svg>
);
export default SvgNavChevronRight;
